export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/errorLogger.49ff597d.worker.js");
}
